"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const changes_subscribers_1 = require("./changes_subscribers");
const errors_1 = require("./errors");
const scheduler_1 = require("./scheduler");
/* IS IDLE */
function isIdle(store) {
    if (store) {
        const changes = changes_subscribers_1.default.get(store);
        if (!changes)
            throw errors_1.default.storeNotFound();
        return !scheduler_1.default.queue.has(changes['_trigger']) && !scheduler_1.default.triggeringQueue.includes(changes['_trigger']);
    }
    else {
        return !scheduler_1.default.triggering && !scheduler_1.default.queue.size;
    }
}
/* EXPORT */
exports.default = isIdle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNfaWRsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9pc19pZGxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFQSxZQUFZOztBQUVaLCtEQUF1RDtBQUN2RCxxQ0FBOEI7QUFDOUIsMkNBQW9DO0FBRXBDLGFBQWE7QUFFYixTQUFTLE1BQU0sQ0FBeUIsS0FBYTtJQUVuRCxJQUFLLEtBQUssRUFBRztRQUVYLE1BQU0sT0FBTyxHQUFHLDZCQUFrQixDQUFDLEdBQUcsQ0FBRyxLQUFLLENBQUUsQ0FBQztRQUVqRCxJQUFLLENBQUMsT0FBTztZQUFHLE1BQU0sZ0JBQU0sQ0FBQyxhQUFhLEVBQUcsQ0FBQztRQUU5QyxPQUFPLENBQUMsbUJBQVMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFHLE9BQU8sQ0FBQyxVQUFVLENBQUMsQ0FBRSxJQUFJLENBQUMsbUJBQVMsQ0FBQyxlQUFlLENBQUMsUUFBUSxDQUFHLE9BQU8sQ0FBQyxVQUFVLENBQUMsQ0FBRSxDQUFDO0tBRXBIO1NBQU07UUFFTCxPQUFPLENBQUMsbUJBQVMsQ0FBQyxVQUFVLElBQUksQ0FBQyxtQkFBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUM7S0FFdkQ7QUFFSCxDQUFDO0FBRUQsWUFBWTtBQUVaLGtCQUFlLE1BQU0sQ0FBQyJ9